<template>
  <!-- eslint-disable -->
<v-container fluid>
<v-slide-y-transition mode="out-in">
  <div>
    <div v-if="!loader">

      <h1>Courier Billing Approval</h1>
      <courier-edit-modal />
      <v-dialog v-model="autoApproveModal" max-width="500px">
        <v-card>
          <v-card-title>
            <h2 class="headline">Auto Approve {{ selectedOrders.length }} orders</h2>
          </v-card-title>
          <v-card-text>
            Clicking auto approve will update the client actual with the client quote and approve the selected orders.
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate color="blue" v-if="disableBtn"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn color="red" text class="auto-approve-orders-approve-btn" @click.native="autoApprove()" :disabled="disableBtn">
              Auto Approve Now
            </v-btn>
            <v-btn color="blue darken-1" class="auto-approve-orders-cancel-btn" text @click.native="autoApproveModal = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="removeFromBillingModal" max-width="500px">
        <v-card>
          <v-card-title>
            <h2 class="headline">Remove {{ selectedOrders.length }} orders from billing</h2>
          </v-card-title>
          <v-card-text>
            Clicking remove from billing will set the selected orders as not billable.
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate color="blue" v-if="disableBtn"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn color="red" text class="auto-remove-orders-approve-btn" @click.native="removeFromBilling()" :disabled="disableBtn">Remove Now</v-btn>
            <v-btn color="blue darken-1" class="auto-remove-orders-cancel-btn" text @click.native="removeFromBillingModal = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn class="filter-to-billable-btn" style="margin: 10px 3px;" @click="filterToBillable()">Orders needing review for this billing period: <span class="orders-needing-review">{{billableOrders.length}}</span> </v-btn>
      <table width="100%">
        <tr>
          <td :style="{'background-color':'green', 'width': + (pendingOrders.filter(x => x.Flag === 0).length/pendingOrders.length * 100) + '%', 'text-align':'center'}">
            <v-btn icon @click="filter(0)" class="order-flag-0-filter-btn">
              <v-chip outlined text-color="white" style="border-color: white;">{{pendingOrders.filter(x => x.Flag === 0).length}}</v-chip>
            </v-btn>
          </td>
          <td :style="{'background-color':'orange', 'width': + (pendingOrders.filter(x => x.Flag === 1).length/pendingOrders.length * 100) + '%', 'text-align':'center'}">
            <v-btn icon @click="filter(1)" class="order-flag-1-filter-btn">
              <v-chip outlined text-color="black" style="border-color: black;">{{pendingOrders.filter(x => x.Flag === 1).length}}</v-chip>
            </v-btn>
          </td>
          <td :style="{'background-color':'#ff7c00', 'width': + (pendingOrders.filter(x => x.Flag === -1).length/pendingOrders.length * 100) + '%', 'text-align':'center'}">
            <v-btn icon @click="filter(-1)" class="order-flag-5-filter-btn">
              <v-chip outlined text-color="black" style="border-color: black;">{{pendingOrders.filter(x => x.Flag === -1).length}}</v-chip>
            </v-btn>
          </td>
          <td :style="{'background-color':'#f46e42', 'width': + (pendingOrders.filter(x => x.Flag === 2).length/pendingOrders.length * 100) + '%', 'text-align':'center'}">
            <v-btn icon @click="filter(2)" class="order-flag-2-filter-btn">
              <v-chip outlined text-color="black" style="border-color: black;">{{pendingOrders.filter(x => x.Flag === 2).length}}</v-chip></v-btn>
          </td>
          <td :style="{'background-color':'red', 'width': + (pendingOrders.filter(x => x.Flag === 3).length/pendingOrders.length * 100) + '%', 'text-align':'center'}">
            <v-btn icon @click="filter(3)" class="order-flag-3-filter-btn">
              <v-chip outlined text-color="white" style="border-color: white;">{{pendingOrders.filter(x => x.Flag === 3).length}}</v-chip></v-btn>
          </td>
          <td :style="{'background-color':'#a5efa6', 'width': + (pendingOrders.filter(x => x.Flag === 4).length/pendingOrders.length * 100) + '%', 'text-align':'center'}">
            <v-btn icon @click="filter(4)" class="order-flag-4-filter-btn">
              <v-chip outlined text-color="black" style="border-color: black;">{{pendingOrders.filter(x => x.Flag === 4).length}}</v-chip>
            </v-btn>
          </td>
          
        </tr>
      </table>
      Filtered to:
      <v-chip close class="clear-filter-btn" v-if="currentFilter > -2" @click:close="filter(-2,currentFilter)">{{getFilterGroup(currentFilter) }}</v-chip>
      <span class="no-filter-text" v-else>All</span>
      <v-btn @click="autoApproveModal = true" class="auto-approve-orders-btn" v-if="currentFilter == 0 && selectedOrders.length > 0" text>
        Auto Approve {{selectedOrders.length}} Orders
      </v-btn>
            <v-btn @click="removeFromBillingModal = true" class="auto-remove-orders-btn" v-if="currentFilter == 3 && selectedOrders.length > 0" text>
        Remove {{selectedOrders.length}} Orders from billing
      </v-btn>

<template>
  <v-container class="grey lighten-5">
    <v-row no-gutters >
      <v-col class="flex-nowrap">
  <v-text-field
        v-model="tableSearch"
        append-icon="mdi-filter"
        label="Filter Tracking #"
        single-line
        hide-details
      ></v-text-field>
      </v-col>
      <v-col class="flex-nowrap">
    <v-text-field
        v-model="dbSearch"
        label="Search Tracking #"
        hide-details
        append-icon="mdi-magnify"
        @click:append="searchDb(dbSearch)"
      ></v-text-field>
     
      </v-col>
    </v-row>
  </v-container>
</template>
<download-excel :data="filteredOrders">
  Download Data
  <v-icon>
  mdi-file-download
</v-icon>
</download-excel>
    


      <v-data-table
        show-select 
        v-model="selectedOrders"
        item-key="Id"
        :mobile-breakpoint="0"
        style="margin-top: 10px;"
        :search="tableSearch"
        class="filtered-orders-data-table no-wrap-th"
        :sort-by.sync="sortBy"
        :sort-desc.sync="descending"
        :items-per-page.sync="rowsPerPage"
        :footer-props="{'items-per-page-options': [50,100,200]}"
        :items="filteredOrders"
        :headers="headers"
      >
        <template v-slot:item="{ item }">
          <tr class="filtered-order" :class="{ doNotBill: item.DoNotBill, approved: item.BillingApproved, 'courier-actual-valid':item.CourierActual > 0}">
            <td>
            
             <v-checkbox v-model="selectedOrders" :value="item" hide-details v-show="currentFilter === 0 || currentFilter == 3"   />
            
            </td>
            <td>
              <v-btn class="edit-order-btn" icon @click="editItem(item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </td>
            
            <td>
              <v-tooltip bottom  v-if="item.Flag == 0">
                <template v-slot:activator="{ on }">
                  <v-icon color="green" v-on="on" class="order-flag-0">thumb_up</v-icon>
                </template>
                <span>Ready for auto approval</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.Flag == 1">
                <template v-slot:activator="{ on }">
                  <v-icon color="orange" v-on="on" class="order-flag-1">report</v-icon>
                </template>
                <span>Needs Review</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.Flag == 2">
                <template v-slot:activator="{ on }">
                  <v-icon color="dark-orange" v-on="on" class="order-flag-2">schedule</v-icon>
                </template>
                <span>Old Order without courier actual</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.Flag == 3">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" v-on="on" class="order-flag-3">block</v-icon>
                </template>
                <span>Do not bill</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.Flag == 4">
                <template v-slot:activator="{ on }">
                  <v-icon color="#a5efa6" v-on="on" class="order-flag-4">schedule</v-icon>
                </template>
                <span>Awaiting courier actual</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.Flag == -1">
                <template v-slot:activator="{ on }">
                  <v-icon color="#ff7c00" v-on="on" class="order-flag-5">outlined_flag</v-icon>
                </template>
                <span>Needs Review (Manually Flagged)</span>
              </v-tooltip>
            </td>
            <td class="order-date-col">{{item.OrderDate}}</td>
            <td>{{item.TrackingNumber}}</td>
            <td>{{item.Courier}}</td>
            <td>{{item.OrderNumber}}</td>
            <td style="background-color:#a8d2f7">{{item.CourierQuote}}</td>
            <td style="background-color:#a8d2f7" class="courier-actual-column">
              <span v-if="item.CourierActual==null">
                <v-icon color="red">error</v-icon>
              </span>
              <span v-else>{{item.CourierActual}}</span>
            </td>
            <td style="background-color:#f9e8b8">{{item.ClientQuote}}</td>
            <td style="background-color:#f9e8b8" class="actual-column">
              <span v-if="item.ClientActual == null">
                <v-icon color="red">error</v-icon>
              </span>
              <span v-else>{{item.ClientActual}}</span>
            </td>
            <td>{{item.ClientName}}</td>
            <td>{{item.LocationName}}</td>
            <td>{{getDeliveredByText(item.DeliveredBy)}}</td>
            <td>{{item.BillingExplanation}}</td>
            <td>
              <v-icon v-if="item.BillingApproved" color="green">done</v-icon>
              <v-icon v-if="item.DoNotBill" color="red">clear</v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <v-container>
            <v-layout row justify-center align-center v-if="loading">
              <v-progress-circular indeterminate color="blue"></v-progress-circular>
            </v-layout>
            <v-layout row justify-center align-center v-else>
              No data to display
            </v-layout>
          </v-container>
        </template>
      </v-data-table>
    </div>
  </div>
  </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import { mapGetters } from "vuex";
import CourierEditModal from "./dialogs/EditMoveModal";
import billingModule, { BILLING_NAMESPACE } from "./store/billingStore";
import JsonExcel from "vue-json-excel";

export default {
  name: "PreliminaryBilling",
  components: {
    "courier-edit-modal": CourierEditModal,
    "downloadExcel": JsonExcel
  },
  data() {
    return {
      selectedOrders: [],
      tableSearch: "",
      dbSearch: "",
      sortBy: "Flag",
      descending: false,
      autoApproveModal: false,
      disableBtn: false,
      loader: true,
      removeFromBillingModal: false,
      currentFilter: -2,
      rowsPerPage: 100,
      headers: [
        {
          text: "",
          value: "",
          sortable: false,
          align: "center"
        },
        {
          text: "Flag",
          value: "Flag",
          align: "center",
          class: "pa-auto"
        },
        {
          text: "Order Date",
          value: "OrderDate",
          align: "left"
        },
        {
          text: "Tracking Number",
          value: "TrackingNumber",
          align: "left"
        },
        {
          text: "Courier Name",
          value: "CourierName"
        },
        {
          text: "Courier Order Number",
          value: "CourierOrderNumber"
        },
        {
          text: "Courier Quote",
          value: "CourierQuote",
          align: "left",
          class: "pa-0"
        },
        {
          text: "Courier Actual",
          value: "CourierActual",
          align: "left",
          class: "pa-0"
        },
        {
          text: "Client Quote",
          value: "ClientQuote",
          align: "left",
          class: "pa-0"
        },

        {
          text: "Client Actual",
          value: "ClientActual",
          align: "left",
          class: "pa-0"
        },
        {
          text: "Client",
          value: "ClientName",
          align: "left"
        },
        {
          text: "Location",
          value: "LocationName",
          align: "left"
        },
        {
          text: "Delivered By",
          value: "DeliveredBy",
          align: "left"
        },
        {
          text: "Billing Expl.",
          value: "Billing Explanation",
          align: "left"
        },
        {
          text: "Approved",
          value: "BillingApproved",
          align: "left",
          class: "pa-0"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(BILLING_NAMESPACE, [
      "pendingOrders",
      "filteredOrders",
      "billableOrders",
      "loading"
    ])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(BILLING_NAMESPACE, billingModule);
    this.$on("auth", this.load);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.BILLING_ADMIN]).then(
      res => {
        if (res) {
          this.$emit("auth");
        } else this.$goHome();
      }
    );
  },
  methods: {
    autoApprove() {
      this.disableBtn = true;
      return this.$store
        .dispatch(
          `${BILLING_NAMESPACE}/AUTO_APPROVE_ORDERS`,
          this.selectedOrders.filter(o => {
            return o.Flag === 0;
          })
        )
        .then(x => {
          this.disableBtn = false;
          this.currentFilter = -2;
          this.autoApproveModal = false;
        });
    },
    filterToBillable() {
      return this.$store.dispatch(`${BILLING_NAMESPACE}/FILTER_TO_BILLABLE`);
    },
    removeFromBilling() {
      this.disableBtn = true;
      return this.$store
        .dispatch(
          `${BILLING_NAMESPACE}/REMOVE_ORDERS`,
          this.selectedOrders.filter(o => {
            return o.Flag === 3;
          })
        )
        .then(x => {
          this.disableBtn = false;
          this.removeFromBillingModal = false;
        });
    },
    editItem(item) {
      // send a copy to the edit dialog
      return this.$emit("edit-courier-move", _.cloneDeep(item));
    },
    getFilterGroup(filterCode) {
      if (filterCode === -1) return "Needs review (Manually Flagged)";
      if (filterCode === 0) return "Ready for auto approval";
      if (filterCode === 1) return "Needs review";
      if (filterCode === 2) return "No courier actual 2+ wks";
      if (filterCode === 3) return "Remove from billing";
      if (filterCode === 4) return "Awaiting courier actual";
      if (filterCode === 5) return "Search";
    },
    load() {
      this.loader = false;
      return this.$store.dispatch(`${BILLING_NAMESPACE}/GET_PENDING_ORDERS`);
    },
    filter(condition, currentFilter) {
      var selectedFilter = currentFilter;
      
      this.selectedOrders = [];
      this.currentFilter = condition;
      return this.$store.dispatch(
        `${BILLING_NAMESPACE}/APPLY_ORDER_FILTER`,
        {data:condition,selected:selectedFilter},
      );
    },
    searchDb(condition) {
      this.selectedOrders = [];
      this.currentFilter = condition;
      this.filter(5);
      return this.$store.dispatch(
        `${BILLING_NAMESPACE}/SEARCH_ORDERS`,
        condition
      );
    },
    getDeliveredByText(enumCode) {
      if (enumCode === 0) return "Courier";
      if (enumCode === 1) return "Carrier";
      return "";
    }
  }
};
</script>
